import React from 'react';
import { TextField, Box, FormControl, RadioGroup, FormControlLabel, Radio, Typography, Checkbox } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import MomentUtils from '@material-ui/pickers/adapter/moment';
import { LocalizationProvider, MobileDatePicker } from '@material-ui/pickers';

import { getPath } from '../../utils/getPath';
import IncDecNumberInput from './fields/IncDecNumberInput';
import PeriodPicker from './fields/PeriodPicker';
import { NumberInput } from '../UI/Form';
import ModelAutocomplete from './fields/ModelAutocomplete';

export const fields = {
    companyName: (name, value, handleChange) => (
        <TextField name={name} value={value || ''} onChange={handleChange} label="Название компании" fullWidth required />
    ),
    contactPerson: (name, value, handleChange) => (
        <TextField name={name} value={value || ''} onChange={handleChange} label="Контактное лицо" fullWidth required />
    ),
    region: (name, value, values, handleChange) => (
        <Autocomplete
            popupIcon={<ExpandMoreIcon />}
            options={values}
            getOptionLabel={region => region}
            value={value}
            onChange={(e, value) => handleChange(name, value)}
            renderInput={params => (
                <TextField
                    {...params}
                    fullWidth
                    label="Регион"
                    helperText="Важно! При смене региона может измениться стоимость аренды товара."
                    required
                />
            )}
            noOptionsText="Нет данных"
        />
    ),
    modelId: (name, value, values, handleChange) => <ModelAutocomplete name={name} value={value} onChange={handleChange} />,
    mountedType: (name, value, handleChange) => (
        <TextField name={name} value={value} onChange={handleChange} label="Тип монтируемых конструкций" fullWidth />
    ),
    weight: (name, value, handleChange) => (
        <TextField name={name} value={value} onChange={handleChange} label="Вес конструкций, кг" fullWidth />
    ),
    liftingHeight: (name, value, handleChange) => (
        <TextField name={name} value={value} onChange={handleChange} label="Высота подъёма, м" fullWidth />
    ),
    service: (name, value, values, handleChange) => (
        <Autocomplete
            popupIcon={<ExpandMoreIcon />}
            options={values}
            getOptionLabel={service => service}
            value={value}
            onChange={(e, value) => handleChange(name, value)}
            renderInput={params => <TextField {...params} fullWidth label="Услуга" required />}
            noOptionsText="Нет данных"
        />
    ),
    days: (name, value, handleChange) => (
        <TextField
            name={name}
            value={value}
            onChange={handleChange}
            label="Количество дней"
            InputProps={{ inputComponent: NumberInput }}
            fullWidth
            required
        />
    ),
    rentPeriod: (name, value, handleChange) => <PeriodPicker name={name} value={value} onChange={handleChange} required />,
    rentDate: (name, value, handleChange) => (
        <LocalizationProvider dateAdapter={MomentUtils} locale="ru">
            <MobileDatePicker
                okText="Выбрать"
                cancelText=""
                showToolbar={false}
                value={value || null}
                onChange={newValue => handleChange(name, newValue)}
                renderInput={props => (
                    <Box position="relative">
                        <TextField {...props} variant="standard" fullWidth helperText="" label="Дата аренды" required />
                        <div className="period-input__calendar-btn">
                            <img src={getPath('public/img/calendar-month.svg')} alt="" />
                        </div>
                    </Box>
                )}
                disableOpenPicker={false}
            />
        </LocalizationProvider>
    ),
    shift: (name, value, values, handleChange) => (
        <Autocomplete
            popupIcon={<ExpandMoreIcon />}
            options={values}
            getOptionLabel={shift => shift}
            value={value}
            onChange={(e, value) => handleChange(name, value)}
            renderInput={params => <TextField {...params} fullWidth label="Смена" required />}
            noOptionsText="Нет данных"
        />
    ),
    comment: (name, value, handleChange) => (
        <TextField
            multiline
            fullWidth
            rows={5}
            name={name}
            value={value}
            onChange={handleChange}
            label="Комментарий к заказу"
            placeholder="Здесь вы можете описать сложности на объекте"
        />
    ),
    glassWeight: (name, value, handleChange) => (
        <TextField name={name} value={value} onChange={handleChange} label="Вес стекла, кг" fullWidth />
    ),
    hoursPerShift: (name, value, handleChange) => (
        <Box width="100%" display="flex" justifyContent="flex-start">
            <FormControl component="fieldset">
                <Box textAlign="left" mb={1}>
                    <Typography>Количество часов в смене</Typography>
                </Box>
                <RadioGroup name={name} value={value} onChange={handleChange} required>
                    <FormControlLabel value="8 часов" control={<Radio style={{ padding: '3px 10px 1px 10px' }} />} label="8 часов" />
                    <FormControlLabel value="16 часов" control={<Radio style={{ padding: '3px 10px 1px 10px' }} />} label="16 часов" />
                </RadioGroup>
            </FormControl>
        </Box>
    ),
    rentHours: (name, value, handleChange) => <IncDecNumberInput name={name} value={value} onChange={handleChange} required />,
    workType: (name, value, handleChange) => <TextField name={name} value={value} onChange={handleChange} label="Тип работ" fullWidth />,
    name: (name, value, handleChange) => (
        <TextField name={name} value={value || ''} onChange={handleChange} label="Имя" fullWidth required />
    ),
    phone: (name, value, handleChange) => (
        <TextField name={name} value={value || ''} onChange={handleChange} label="Телефон" fullWidth required />
    ),
    fillerType: (name, value, values, handleChange) => (
        <Autocomplete
            popupIcon={<ExpandMoreIcon />}
            options={values}
            getOptionLabel={filler => filler}
            value={value}
            onChange={(e, value) => handleChange(name, value)}
            renderInput={params => <TextField {...params} fullWidth label="Тип наполнителя" />}
            noOptionsText="Нет данных"
        />
    ),
    size: (name, value, handleChange) => (
        <TextField name={name} value={value} onChange={handleChange} label="Длина/ширина/толщина, мм" fullWidth />
    ),
    usePrivileges: (name, value, handleChange) => (
        <Box width="100%" display="flex" justifyContent="flex-start">
            <FormControlLabel
                control={<Checkbox name={name} checked={value} onChange={handleChange} />}
                label="Воспользоваться привилегией"
            />
        </Box>
    ),
};
